module.exports = __webpack_public_path__ + "static/media/mammories.8a56af2e.png";